import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import { Box } from '@mui/material';
import { WizardRowItem } from 'common';
import { SequencingWizardContext } from '../../SequencingWizardContext';
import InventoryOwnerAutoComplete from '../../components/InventoryOwnerAutoComplete.connector';
import Buttons from '../../components/Buttons';

const RemoveStep1 = props => {
  const { next, prev } = props;
  const {
    data: { currentAffiliate, inventoryOwners = [] },
    setData,
  } = useContext(SequencingWizardContext);

  const continueDisabled = R.isEmpty(inventoryOwners);

  const handleAdd = inventoryOwner =>
    setData(
      R.evolve({
        inventoryOwners: R.append(inventoryOwner),
        loadProducts: R.T,
        products: R.empty,
      })
    );

  const handleRemove = inventoryOwner =>
    setData(
      R.evolve({
        inventoryOwners: R.reject(R.equals(inventoryOwner)),
        loadProducts: R.T,
        products: R.empty,
      })
    );

  const renderRow = inventoryOwner => (
    <WizardRowItem
      key={inventoryOwner.companyCustomerIdName}
      name={`${inventoryOwner.companyCustomerIdName} ${inventoryOwner.nameShort}`}
      onRemove={() => handleRemove(inventoryOwner)}
    />
  );

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          // height of other components is 157px
          // prevents progress bar from looking off
          height: 'calc(100% - 157px)',
          overflowY: 'auto',
        }}
      >
        <InventoryOwnerAutoComplete
          autoClear
          currentAffiliate={currentAffiliate}
          onChange={handleAdd}
          title="Select one or more Inventory Owners to remove"
          without={inventoryOwners}
        />
        <Box flexGrow={1}>{R.map(renderRow, inventoryOwners)}</Box>
      </Box>
      <Buttons
        disabled={continueDisabled}
        handleLeftButtonClick={prev}
        handleRightButtonClick={next}
        leftLabel="Back"
        rightLabel="Continue"
      />
    </>
  );
};

RemoveStep1.propTypes = {
  next: PropTypes.func.isRequired,
  prev: PropTypes.func.isRequired,
};

export default RemoveStep1;
